import { useCallback, useMemo, useState } from 'react';
// Custom hooks.
// -----------------------------------------------------------------------------
export const useTextField = (type) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const [showPassword, setShotPassword] = useState(false);
    const inputType = useMemo(() => (type !== 'password' ? type : showPassword ? 'text' : 'password'), [showPassword, type]);
    // Helpers.
    // ---------------------------------------------------------------------------
    const handleClickShowPassword = useCallback(() => {
        setShotPassword((prev) => !prev);
    }, []);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        inputType,
        onClickShowPassword: handleClickShowPassword
    };
};
//# sourceMappingURL=TextField.hooks.js.map